import { render, staticRenderFns } from "./RatedSkillComponent.vue?vue&type=template&id=060191cc&scoped=true&"
import script from "./RatedSkillComponent.vue?vue&type=script&lang=js&"
export * from "./RatedSkillComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060191cc",
  null
  
)

export default component.exports